import React from "react";
import PrintField from "../../shared/PrintField";
import "./InvitationEGM2_EN.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const InvitationEGM2_EN = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      {/* ใช้ inv-en ตาม css */}
      <div className="inv-paper inv-en" ref={ref}>
        {/* Title */}
        <div className="en-title en-bold">Company Dissolution Announcement</div>

        {/* Company (center) */}
        <div className="en-center-line">
          <InputField className="en-input long" /> <span className="en-bold">Co., Ltd.</span>
        </div>

        {/* Paragraph 1 */}
        <p className="en-paragraph en-left-par">
  I would like to announce that the Extraordinary General Meeting No.
  <InputField className="en-input tiny" />/<InputField className="en-input tiny" /> of{" "}
  <InputField className="en-input long" /> <span className="en-bold">Co., Ltd.</span> has
  resolved that the Company shall be dissolved since{" "}
  <InputField className="en-input long" />
</p>

<p className="en-paragraph en-left-par">
  I hereby call any debtors and creditors of the Company to make payment to or demand
  payment from me at my office at <InputField className="en-input xlong" />, within{" "}
  <span className="en-bold">7</span> days as from the date of this announcement.
</p>


       {/* Announced + Signature (centered like image 1) */}
<div className="en-sign-center">
  <div className="en-announced-line">
    <span className="en-bold">Announced on</span>
    <span className="en-dots w-220"></span>
  </div>

  <div className="en-sign-name en-bold">( <InputField className="en-input long" /> )</div>
  <div className="en-sign-role en-bold">The Liquidator</div>
</div>

      </div>
    </div>
  );
});

export default InvitationEGM2_EN;
